import { object, string, create, pattern, nullable, enums } from 'superstruct'

import { Belt, BELT_NAMES } from './belt'

export const CreateParams = object({
  type: string(),
  belt: nullable(enums(BELT_NAMES)),
  occurredAt: pattern(string(), /\d\d\d\d-\d\d-\d\d/)
})

export class AthleteActivity {
  static create(params) {
    return new AthleteActivity(create(params, CreateParams))
  }

  constructor(params) {
    Object.assign(this, params)

    this.belt = params.belt && Belt.create({ name: params.belt })
  }
}
